import { useDisclosure as useMantineDisclosure } from '@mantine/hooks';

type UseDisclosureReturn = {
	isOpen: boolean;
	open: () => void;
	close: () => void;
};

export function useModal() {
	const [show, { open, close }] = useMantineDisclosure(false);

	const disclosure: UseDisclosureReturn = {
		open: open,
		close: close,
		isOpen: show,
	};

	return disclosure;
}
